import React from 'react';
import StrengthsAndWeaknessesByTeam from 'components/manager-dashboard/strengths-and-weaknesses/StrengthsAndWeaknessesByTeam';
import ManagerStrengthsAndWeaknesses from 'components/dashboard/manager/ManagerStrengthsAndWeaknesses';
import AdminSuggestedActionsContainer from 'components/dashboard/admin/AdminSuggestedActionsContainer';
import './AdminDashTeamSkills.styl';

export default class AdminDashTeamSkills extends React.PureComponent {
  render() {
    return (
      <div className="dashv2-widget standalone-widget-wrapper">
        <ManagerStrengthsAndWeaknesses
          {...this.props}
          child={StrengthsAndWeaknessesByTeam}
          useTeam={false}
          widgetId="strengths_and_weakness"
          widgetType="TEAM_SCORECARDS"
        />
        <AdminSuggestedActionsContainer {...this.props} />
      </div>
    );
  }
}
